module.exports = {
  url: window.location.origin,
};
